import { useAuthStore } from '@/store/use-auth-store';
import type { AuthTenant } from '@/types/tenant';
import { getPostLoginReturnPath } from '@/utils/post-login-return-path';
import { syncAuthScopeFromCurrentUser } from '@/utils/sync-auth-scope';
import { useNavigate } from 'react-router-dom';

/**
 * Finish a password login for users with several tenants: leave the tenant
 * selector and open the chosen tenant — at the link they came in from when it
 * belongs to that tenant, otherwise at Home.
 */
export function useEnterTenant() {
  const navigate = useNavigate();
  const { setSession, setShowTenantSelector } = useAuthStore();

  return (tenant: AuthTenant) => {
    const returnPath = getPostLoginReturnPath([tenant]);

    setSession('password');
    setShowTenantSelector(false);
    navigate(returnPath ?? `/${tenant.slug}/home`, { replace: true });
    syncAuthScopeFromCurrentUser({ tenantId: tenant.id }).catch((error) => {
      console.error('Failed to sync cohort scope after tenant select', error);
    });
  };
}
